// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"05803ba5","247":"a6b3720b","453":"785134cd","627":"08378cbf","653":"c5f182c5","738":"0080a78d","768":"4a3679b9","834":"ebca8967","923":"d7ccc037","938":"6a52d3f7"}[chunkId] + ".chunk.js";
};